declare namespace $ {

	export class $bog_merchquarium_gallery extends $mol_view {
		items( ): readonly($mol_view)[]
		sub( ): ReturnType< $bog_merchquarium_gallery['items'] >
	}
	
}

//# sourceMappingURL=gallery.view.tree.d.ts.map